import React, { useState, useEffect } from 'react';
import {
  AppBar, Avatar, Divider, IconButton, List, ListItemButton,
  Toolbar,
  Tooltip,
} from '@mui/material'
import Box from '@mui/material/Box';
import { Button, Col } from 'react-bootstrap';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import ChecklistIcon from '@mui/icons-material/Checklist';
import HomeIcon from '@mui/icons-material/Home';
import VerifiedIcon from '@mui/icons-material/Verified';
import SendIcon from '@mui/icons-material/Send';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { TbSend } from "react-icons/tb";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { FcBusinessman } from "react-icons/fc";
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import {
  Accounts, Billing_Details, BillReportData, DailyReportData, FundReportData, OpretionReportData,
  PaymentEstimationData, Place, SidebarData
} from './sidebar/SidebarData';
import SubMenu from './sidebar/SubMenu';
import { getplaceSession, getUser, getUserTypeSession } from '../Utils/Common';
import { ImSwitch } from "react-icons/im";
import { BiChevronsDown } from "react-icons/bi";
import MenuIcon from '@mui/icons-material/Menu';
// import AuthenticationService from '../../Services/AuthenticationService';
import IdleTimerContainer from '../IdleTimerContainer';

const SidebarNav = styled.nav`
font-wight:500;
  width: 290px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);
  

    top: 10;
  left: ${({ sidebar }) => (sidebar ? '2.5%' : '-100%')};
  transition:'25s';
  transition-delay:'revert-layer';
  z-index: 10;
`;
const SidebarNav1 = styled.nav`
font-wight:500;
  width: 420px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);
  

    top: 10;
  left: ${({ sidebar }) => (sidebar ? '2.5%' : '-100%')};
  transition:'25s';
  transition-delay:'revert-layer';
  z-index: 10;
`;
const SidebarNav2 = styled.nav`
font-wight:500;
  width: 310px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);
  

    top: 10;
  left: ${({ sidebar }) => (sidebar ? '2.5%' : '-100%')};
  transition:'25s';
  transition-delay:'revert-layer';
  z-index: 10;
`;
const SidebarNav3 = styled.nav`
font-wight:500;
  width: 290px;
  height: 100vh;
  position: fixed;
  z-index: 10;
  box-shadow: 0 16px 15px 15px rgb(126 55 216 / 3%);
  

    top: 10;
  left: ${({ sidebar }) => (sidebar ? '2.5%' : '-100%')};
  transition:'25s';
  transition-delay:'revert-layer';
  z-index: 10;
`;
function Home(props) {

  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = React.useState(3);

  const [placevisible, setplacevisible] = useState(true)
  const [billRepvisible, setbillRepvisible] = useState(true)
  const [Billreports_hidden, setBillreports_hidden] = useState(false)
  const [billing_edit_hidden, setbilling_edit_hidden] = useState(false)
  const [billing_hidden, setbilling_hidden] = useState(false)
  const [fundRepvisible, setfundRepvisible] = useState(true)
  const [dailyStsRepvisible, setdailyStsRepvisible] = useState(true)
  const [operRepvisible, setoperRepvisible] = useState(true)
  const [billvisible, setbillvisible] = useState(true)
  const [acc_visible, setacc_visible] = useState(true)

  const placeBarOnclick = () => {
    setplacevisible(!placevisible)
    setbillRepvisible(true)
    setfundRepvisible(true)
    setdailyStsRepvisible(true)
    setoperRepvisible(true)
    setbillvisible(true)
    setacc_visible(true)
  }
  const BillRepOnclick = () => {
    setbillRepvisible(!billRepvisible)
    setplacevisible(true)
    setfundRepvisible(true)
    setdailyStsRepvisible(true)
    setoperRepvisible(true)
    setbillvisible(true)
    setacc_visible(true)
  }
  const FundRepOnclick = () => {
    setfundRepvisible(!fundRepvisible)
    setplacevisible(true)
    setbillRepvisible(true)
    setdailyStsRepvisible(true)
    setoperRepvisible(true)
    setbillvisible(true)
    setacc_visible(true)
  }
  const DailyRepOnclick = () => {
    setdailyStsRepvisible(!dailyStsRepvisible)
    setplacevisible(true)
    setbillRepvisible(true)
    setfundRepvisible(true)
    setoperRepvisible(true)
    setbillvisible(true)
    setacc_visible(true)
  }
  const OprRepOnclick = () => {
    setoperRepvisible(!operRepvisible)
    setplacevisible(true)
    setbillRepvisible(true)
    setfundRepvisible(true)
    setdailyStsRepvisible(true)
    setbillvisible(true)
    setacc_visible(true)
  }
  const BillingBarOnclick = () => {
    setbillvisible(!billvisible)
    setplacevisible(true)
    setbillRepvisible(true)
    setfundRepvisible(true)
    setdailyStsRepvisible(true)
    setoperRepvisible(true)
    setacc_visible(true)
  }
  const AccBarOnclick = () => {
    setacc_visible(!acc_visible)
    setplacevisible(true)
    setbillRepvisible(true)
    setfundRepvisible(true)
    setdailyStsRepvisible(true)
    setoperRepvisible(true)
    setbillvisible(true)
  }

  const [Genarel, setGenarel] = useState(false);
  const [Report, setReport] = useState(false);
  const [Fund, setFund] = useState(false);
  const [Master, setMaster] = useState(false);
  // const open = Boolean(anchorEl);


  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    if (index === 0) {
      setGenarel(!Genarel);
      setReport(false)
      setFund(false)
      setMaster(false)
    } else if (index === 1) {
      setGenarel(false);
      setReport(false)
      setFund(!Fund)
      setMaster(false)
    } else if (index === 2) {
      setGenarel(false);
      setFund(false);
      if (getUserTypeSession() === 'Accounts_admin' || getUserTypeSession() === 'ACCOUNTS') {
        setBillreports_hidden(false)
      } else {
        setBillreports_hidden(true)
      }
      setReport(!Report)
      setMaster(false)
    } else if (index === 3) {
      setMaster(!Master);
      setGenarel(false);
      setFund(false);
      setReport(false)
    } else if (index === 4) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/CustomActivity')
    } else if (index === 5) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/BeSbUpdation')
    } else if (index === 6) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/Tracking')
    } else if (index === 13) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      navigate('/trans_pay')
    } else if (index === 12) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false);
      navigate('/bl_entry')
    } else if (index === 7) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/checklistApprovalbMngr')
    } else if (index === 8) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/checklistSndParty')
    } else if (index === 9) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/checklistVerify')
    }else if (index === 10) {
      setMaster(false);
      setGenarel(false);
      setFund(false);
      setReport(false)
      navigate('/billedit')
    }
    // onmouseleave(handleClosesidebar(event))
  };

  // const handleMenu = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  const handleClosesidebar = (e) => {
    setMaster(false);
    setGenarel(false);
    setFund(false);
    setReport(false);
  };
  // const hideAndShowNav = () => {
  //   setMenubar(!menuBar);
  //   setGenarel(false);
  // }

  const menu_velidete = async () => {
    if (getUserTypeSession() === 'Accounts_admin') {
      setbilling_hidden(false)
    } else {
      setbilling_hidden(true)
    }
    if (getUserTypeSession() === 'billing_admin') {
      setbilling_edit_hidden(false)
    } else {
      setbilling_edit_hidden(true)
    } 
  }

//   const loginPage = (e) => {
   
//     // Call Authentication service
//     AuthenticationService.executeJwtAuthenticationService().then((response) => {
//         // console.log('APILogin=>' + JSON.stringify("Barear " + response.data.token));
//         setUserSession("Bearer " + response.data.token, getUser())
//         // setUserSession("Bearer ", values.txt_userName)
//        // AuthenticationService.registerSuccessfulLoginForJwt(values.txt_userName,response.data.token);


//     }).catch(error => {
//     });
// }


  useEffect(() => {
    // setTimeout(() => {
    //   loginPage();
    // }, 16000000)
    
    menu_velidete()
  }, []);

  const logout = () => {
    navigate('/')
  }
  const home = () => {
    navigate('/home')
  }
  return (
    <div>
      <IdleTimerContainer/>
      <div style={{ marginBottom: '130px' }}>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar variant='elevation' position='fixed'>
            <Toolbar className='tabsCss'>
            <Tooltip title="Home" arrow><IconButton><MenuIcon className='!text-white' onClick={home} /></IconButton></Tooltip>
              <div className='!flex flex-col !ml-5'>
              <div className='!ml-5 !text-white !text-2xl !font-bold'>SCOPE</div>
              <span className='!ml-5 !text-sm !uppercase'>Freight Forwarders</span>
              </div>
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <div className='!flex items-center gap-3'>
              <Avatar className='!w-11 !h-11'><FcBusinessman className='!w-[40px] !h-[40px]' /></Avatar>
                <label className='UserCss'>  {getUser()}</label>&nbsp;
                </div>
                <Divider orientation="vertical" variant="middle" flexItem></Divider>&nbsp;
                <div  className='!flex items-center'>
               <Tooltip title="Location" arrow> <IconButton className='!w-12 !h-12'><LocationOnIcon  className='text-green-500' /></IconButton></Tooltip>
                <label className='placecss' > {getplaceSession()}</label>&nbsp;
                </div>
                <Divider orientation="vertical" variant="middle" flexItem></Divider>&nbsp;&nbsp;&nbsp;

              </Box>
              <Tooltip title="Logout" arrow><IconButton className='!bg-white !ml-4' onClick={logout} ><ImSwitch className='!text-green-500 hover:!text-[red]' /></IconButton></Tooltip>
              {/* <Typography variant="h6" component="div" sx={{flexGrow:1}}> </Typography>
            <span><BiCalendar/> {dateState.toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                })} <BiAlarm/> {dateState.toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                  second:'numeric',
                  hour12: true,
              })}</span> */}
              {/* <IconButton  aria-label="account of current user"aria-controls="menu-appbar"aria-haspopup="true"
          onClick={handleMenu} color="inherit"> */}
              {/* <img alt="Remy Sharp" src={avatar} className='avatar' onClick={handleMenu}
            /> */}

              {/* <Menu id="menu-appbar" anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'center', horizontal: 'left', }}
              keepMounted transformOrigin={{ vertical: 'center', horizontal: 'left', }}
              open={open} onClose={handleClose} onMouseLeave={handleClose} >
              <Container>
                <Typography variant="caption" display="block" gutterBottom>{getUser()}</Typography>
                <Typography variant="subtitle2">{getplaceSession()}</Typography>
                <Typography variant="subtitle2">{getDate()}</Typography>
              </Container>
            </Menu> */}
            </Toolbar>
          </AppBar>
        </Box>
      </div>
      <div style={{ marginTop: '-68px' }}>
        <div className="sidenav custom-scrollbar">
          <List component="nav" className='flex flex-col !w-[90px]' >
            <ListItemButton selected={selectedIndex === 3}
              onClick={(event) => handleListItemClick(event, 3)}>
               <Col className='cntrtxt '>
              <IconButton><HomeIcon className='!text-white'  /></IconButton>
              <label className='!text-sm !text-white !cursor-pointer'>MASTER</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 7}
              onClick={(event) => handleListItemClick(event, 7)}>
              <Col className='cntrtxt '>
              <IconButton><ChecklistIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>CheckList Approval By Manager</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 8}
              onClick={(event) => handleListItemClick(event, 8)}>
              <Col className='cntrtxt '>
              <IconButton><SendIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>CheckList Send To Party</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 9}
              onClick={(event) => handleListItemClick(event, 9)}>
              <Col className='cntrtxt '>
              <IconButton><VerifiedIcon className='!text-white' /></IconButton>
                <label  className='!text-xs !text-white !cursor-pointer !uppercase'>CheckList Verify By Party</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 4}
              onClick={(event) => handleListItemClick(event, 4)}>
              <Col className='cntrtxt '>
               <IconButton><SupportAgentIcon className='!text-white' /></IconButton>
                <label  className='!text-xs !text-white !cursor-pointer !uppercase'>Custom Activity Entry</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 5}
              onClick={(event) => handleListItemClick(event, 5)}>
              <Col className='cntrtxt '>
              <IconButton><FileOpenIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>BE/SB Updation</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 6}
              onClick={(event) => handleListItemClick(event, 6)}>
              <Col className='cntrtxt '>
              <IconButton><MyLocationIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>Tracking</label>
              </Col>
            </ListItemButton>
            <Divider />
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 12}
              onClick={(event) => handleListItemClick(event, 12)}>
              <Col className='cntrtxt '>
              <IconButton><ContentPasteGoIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>BL/Entry</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 13}
              onClick={(event) => handleListItemClick(event, 13)}>
              <Col className='cntrtxt '>
              <IconButton><LocalShippingIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>Billing Transport</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton divider selected={selectedIndex === 1}
              onClick={(event) => handleListItemClick(event, 1)}>
              <Col className='cntrtxt'>
              <IconButton><CurrencyRupeeIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>Fund Request</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton selected={selectedIndex === 0} hidden={billing_hidden}
              onClick={(event) => handleListItemClick(event, 0)}>
              <Col className='cntrtxt'>
              <IconButton><ReceiptLongIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>Billing</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton divider selected={selectedIndex === 2}
              onClick={(event) => handleListItemClick(event, 2)}>
              <Col className='cntrtxt '>
              <IconButton><TextSnippetIcon className='!text-white' /></IconButton>
                <label className='!text-xs !text-white !cursor-pointer !uppercase'>Reports</label>
              </Col>
            </ListItemButton>
            <Divider />
            <ListItemButton onMouseEnter={(e) => handleClosesidebar(e)} divider selected={selectedIndex === 10} hidden={billing_edit_hidden}
              onClick={(event) => handleListItemClick(event, 10)}>
              <Col className='cntrtxt '>
                <label className='listitemCss'> <TbSend fontSize={15} />Bill Edit</label>
              </Col>
            </ListItemButton>
            <Divider />
            <br></br>
            <Divider />
            <br></br>
            <Divider />
          </List>
        </div>
        <SidebarNav sidebar={Genarel} className='scrollbar scrollbar-secondary sidebarBodynavcss !ml-10'>
          <ul >
            <li className='iconbar-header'>Billings</li>
            {SidebarData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </ul>
          <br></br>
          <Divider></Divider>
        </SidebarNav>
        <SidebarNav1 sidebar={Report} className='scrollbar scrollbar-secondary sidebarBodynavcss !ml-10'>
          <ul>
            <br />
            <h6 className='subMenu_header'>REPORTS</h6></ul>
          <ul hidden={Billreports_hidden}>
            <Button className='iconbar-header buttoncss' onClick={BillRepOnclick}>Bill Report <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (billRepvisible ? (
                <div></div>
              ) : (
                BillReportData.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              ))}
          </ul>
          <Divider></Divider>
          <ul>
            <Button className='iconbar-header buttoncss' onClick={FundRepOnclick}>Fund Report <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (fundRepvisible ? (
                <div></div>
              ) : (
                FundReportData.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              ))
            }
          </ul>
          <Divider></Divider>
          <ul>
            <Button className='iconbar-header buttoncss' onClick={DailyRepOnclick}>Daily Sts Report <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (dailyStsRepvisible ? (
                <div></div>
              ) : (
                DailyReportData.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              ))
            }
          </ul>
          <Divider></Divider>
          <ul>
            <Button className='iconbar-header buttoncss' onClick={OprRepOnclick}>Operation Report <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (operRepvisible ? (
                <div></div>
              ) : (
                OpretionReportData.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              ))
            }
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
          <br></br>
          <br></br>
        </SidebarNav1>
        <SidebarNav2 sidebar={Fund} className='scrollbar scrollbar-secondary sidebarBodynavcss !ml-10'>
          <ul >
            <li className='iconbar-header'>Payment EstimationData</li>
            {PaymentEstimationData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
        </SidebarNav2>
        <SidebarNav3 sidebar={Master}  className='scrollbar scrollbar-secondary sidebarBodynavcss !ml-10'>
          <ul ><br />
            <h6 className='subMenu_header'>MASTER</h6>
            <Button className='iconbar-header buttoncss' onClick={placeBarOnclick}>Place <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (placevisible ? (
                <div></div>
              ) : (
                Place.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              )
              )
            }
          </ul>
          <Divider></Divider>
          <ul >
            <Button className='iconbar-header buttoncss' onClick={BillingBarOnclick}>Billing <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (billvisible ? (
                <div></div>
              ) : (
                Billing_Details.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              ))
            }
          </ul>
          <Divider></Divider>
          <ul >
            <Button className='iconbar-header buttoncss' onClick={AccBarOnclick}>Accounts <span className='arrowicon'><BiChevronsDown /></span></Button>{
              (acc_visible ? (
                <div></div>
              ) : (
                Accounts.map((item, index) => {
                  return <SubMenu item={item} key={index} />;
                })
              ))
            }
          </ul>
          <br></br>
          <Divider></Divider>
          <br></br>
        </SidebarNav3>
      </div>
    </div >
  )
}

export default Home

